var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8287 6.1302L12.8444 2.14593C12.7514 2.05289 12.6245 2 12.4922 2H5.51953C4.69566 2 4.02539 2.67027 4.02539 3.49414V17.5059C4.02539 18.3297 4.69566 19 5.51953 19H15.4805C16.3043 19 16.9746 18.3297 16.9746 17.5059V6.48242C16.9746 6.34662 16.9176 6.21909 16.8287 6.1302ZM12.9902 3.70043L15.2742 5.98438H13.4883C13.2137 5.98438 12.9902 5.76095 12.9902 5.48633V3.70043ZM15.4805 18.0039H5.51953C5.24491 18.0039 5.02148 17.7805 5.02148 17.5059V3.49414C5.02148 3.21952 5.24491 2.99609 5.51953 2.99609H11.9941V5.48633C11.9941 6.3102 12.6644 6.98047 13.4883 6.98047H15.9785V17.5059C15.9785 17.7805 15.7551 18.0039 15.4805 18.0039Z",
    fill: "#494949",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4883 9.03906H7.51172C7.23666 9.03906 7.01367 9.26205 7.01367 9.53711C7.01367 9.81216 7.23666 10.0352 7.51172 10.0352H13.4883C13.7633 10.0352 13.9863 9.81216 13.9863 9.53711C13.9863 9.26205 13.7633 9.03906 13.4883 9.03906Z",
    fill: "#494949",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4883 11.0312H7.51172C7.23666 11.0312 7.01367 11.2542 7.01367 11.5293C7.01367 11.8044 7.23666 12.0273 7.51172 12.0273H13.4883C13.7633 12.0273 13.9863 11.8044 13.9863 11.5293C13.9863 11.2542 13.7633 11.0312 13.4883 11.0312Z",
    fill: "#494949",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4883 13.0234H7.51172C7.23666 13.0234 7.01367 13.2464 7.01367 13.5215C7.01367 13.7965 7.23666 14.0195 7.51172 14.0195H13.4883C13.7633 14.0195 13.9863 13.7965 13.9863 13.5215C13.9863 13.2464 13.7633 13.0234 13.4883 13.0234Z",
    fill: "#494949",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4961 15.0156H7.51172C7.23666 15.0156 7.01367 15.2386 7.01367 15.5137C7.01367 15.7887 7.23666 16.0117 7.51172 16.0117H11.4961C11.7711 16.0117 11.9941 15.7887 11.9941 15.5137C11.9941 15.2386 11.7711 15.0156 11.4961 15.0156Z",
    fill: "#494949",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentFileIcon);
export default __webpack_public_path__ + "static/media/student_file_icon.edf3c92982a72d92ca92cec00cedcf58.svg";
export { ForwardRef as ReactComponent };